var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{ref:"Form",attrs:{"id":_vm.id,"funcionalidade":"livro-talidomida"},on:{"model-load":function($event){return _vm.$emit('model-load', $event)},"save":function($event){return _vm.$emit('save', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }